module.exports = __webpack_public_path__ + "img/programme_icon_xiaochengxu.f1750efd.png";